var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuReaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-reaction") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-reaction",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(1.500000, 1.500000)",
    stroke: "#606060",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "smile"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.44881775,0.311358078 C7.82273948,0.109206797 7.15489228,0 6.46153846,0 C2.89292931,0 0,2.89292931 0,6.46153846 C0,10.0301476 2.89292931,12.9230769 6.46153846,12.9230769 C10.0301476,12.9230769 12.9230769,10.0301476 12.9230769,6.46153846 C12.9230769,5.77844157 12.8170773,5.12010222 12.6206292,4.50207164",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87692308,7.75384615 C3.87692308,7.75384615 4.84615385,9.04615385 6.46153846,9.04615385 C8.07692308,9.04615385 9.04615385,7.75384615 9.04615385,7.75384615",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.52307692,
    y1: 4.52307692,
    x2: 4.52953846,
    y2: 4.52307692,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.4,
    y1: 4.52307692,
    x2: 8.40646154,
    y2: 4.52307692,
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "user-plus",
    transform: "translate(9.046154, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.93846154,
    y1: 0,
    x2: 1.93846154,
    y2: 3.87692308,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.87692308,
    y1: 1.93846154,
    x2: 0,
    y2: 1.93846154,
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuReaction);
export default __webpack_public_path__ + "static/media/menu-reaction.3adfbab12393589b7f2bea9cfa19ae67.svg";
export { ForwardRef as ReactComponent };